import makeApiRequest from './makeApiRequest';

const apiRequest = makeApiRequest();

export const getStatistics = () => {
    return apiRequest.get('/api/pf126/statistics');
};

export default {
    getStatistics
};